import { RowSizes } from "~/components/DataGrid";
import { DataGrid, DataGridRow } from "~/components/DataGrid";
import { ApiQuery, QueryResponse } from "~/modules/filters/types";
import { TokenHoldersColumns } from "~/modules/token_holders/types";
import { TOKEN_HOLDER_COLUMNS } from "./columns";
import { TokenHolderRowData } from "./types";

// // // //

export function TokenHoldersTable(props: {
    query: ApiQuery;
    setQuery: (updated: ApiQuery) => void;
    queryResponse: QueryResponse<TokenHolderRowData>;
}) {
    const { queryResponse, query, setQuery } = props;
    const { results } = queryResponse;

    return (
        <DataGrid
            query={query}
            columns={TOKEN_HOLDER_COLUMNS}
            rows={results}
            rowKey="key"
            bordered
            size={RowSizes.small}
            analyticsTableName="token-holders"
            paginationState={{
                ...queryResponse.pagination,
                page: query.pagination.page,
                perPage: query.pagination.perPage,
            }}
            enableScrollbar={false}
            onChangeQuery={setQuery}
            enablePagerPagination
            includeDummyRows
            flush
        >
            {({ row, rowIndex, scrollLeft }) => (
                <DataGridRow<TokenHolderRowData, TokenHoldersColumns>
                    row={row}
                    columns={TOKEN_HOLDER_COLUMNS}
                    size={RowSizes.small}
                    bordered
                    scrollLeft={scrollLeft}
                    striped={rowIndex % 2 === 1}
                />
            )}
        </DataGrid>
    );
}
